import React from 'react';
import { UserOutlined, TeamOutlined } from '@ant-design/icons';

const ChatHeader = ({ selectedUser, selectedGroup,chatType }) => {
 

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '10px',
        border: '1px solid #ddd',
        background: '#fff',
        height: '60px',
      }}
    >
      {chatType==='group' ? (
        
        <>
          <TeamOutlined
            style={{
              fontSize: '24px',
              color: '#1890ff',
              marginRight: '10px',
            }}
          />
          <h2 style={{ margin: 0, fontSize: '18px' }}>
            {selectedGroup?.name || ''} {/* Fallback to 'Unnamed Group' if name is missing */}
          </h2>
        </>
      ) : chatType==='direct' ? (
        <>
          <UserOutlined
            style={{
              fontSize: '24px',
              color: '#1890ff',
              marginRight: '10px',
            }}
          />
          <h2 style={{ margin: 0, fontSize: '18px' }}>
            {selectedUser?.Name || ''} {/* Fallback to 'Unnamed User' if Name is missing */}
          </h2>
        </>
      ) : (
        <h2 style={{ margin: 0, fontSize: '18px', color: '#888' }}>
          Select a chat
        </h2>
      )}
    </div>
  );
};

export default ChatHeader;
